export function LogoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.157 8.822c.389.83.708 1.73 1.408 3.876l.006.018c.707 2.166 1.025 3.071 1.45 4.011.293.646.583 1.155.9 1.544.467.574 1.022.929 1.71.929.913 0 1.682-.4 2.216-1.113.42-.563.678-1.289.82-2.17.214-1.342.16-3.045-.093-5.117-.286-2.344-.752-4.239-1.413-5.695a1.2 1.2 0 10-2.185.991c.547 1.206.957 2.874 1.216 4.994.228 1.868.276 3.378.105 4.448-.085.53-.219.907-.372 1.112a.37.37 0 01-.13.121l-.013-.015c-.164-.201-.36-.545-.574-1.019-.375-.828-.68-1.693-1.356-3.766l-.006-.018c-.734-2.25-1.069-3.194-1.516-4.149-.313-.667-.625-1.181-.977-1.561-.537-.581-1.21-.884-1.966-.71-.802.184-1.368.772-1.708 1.618-.265.659-.411 1.51-.46 2.575-.092 1.98.153 4.79.73 8.46a1.2 1.2 0 102.37-.372c-.553-3.524-.786-6.192-.703-7.978.032-.698.112-1.24.227-1.612.097.16.203.361.314.598z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
